import { NgModule } from '@angular/core';
import { provideCommonDeclarativeFormsFeatures } from './declarative-forms-common.provider';

@NgModule({
  providers: [provideCommonDeclarativeFormsFeatures()],
})
export class DeclarativeFormsCommonModule {}
